import { Component, OnInit } from '@angular/core';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-offers-list',
	templateUrl: './offers-list.component.html',
	styleUrls: ['./offers-list.component.css'],
})
export class OffersListComponent implements OnInit {
	loader = false;
	offers = [];
	filters = {};
	tableRows = [
		{
			id: 'id',
			name: 'ID',
		},
		{
			id: 'code',
			name: 'Kod',
		},
		{
			id: 'name',
			name: 'Nazwa',
		},
	];

	constructor(private readonly api: Data2Service) {}

	ngOnInit(): void {
		this.loader = true;
		this.loadData();
	}

	private loadData() {
		const parms: string = this.getChecked();
		this.api.get('/istourOffers/?' + parms, (result, error) => {
			this.offers = result.data;
			this.loader = false;
		});
	}

	protected getChecked(): string {
		let checked = '';
		for (const key in this.filters) {
			if (this.filters[key]?.length) {
				checked += '&' + key + '=' + this.filters[key];
			}
		}
		return checked;
	}

	filtersOpen() {
		const element = document.getElementById('filtersModal');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}
}
